// v2.21.2 (owner 2026-10-28): the bell panel on narrow screens (iPhone 11 = 414 px, Safari) ran off the left edge,
// because it hung from the bell's right edge while Bantuan/password/logout sit to the right of the bell.
// Below `sm` (640 px) the panel is fixed to the screen: full width with a small gap that respects the iPhone safe area,
// just under the 4 rem top bar; titles wrap and only the list scrolls (overscroll-contain keeps the page still).
// From `sm` up the classes are exactly the ones before v2.21.2 (computer view unchanged).
export const KELAS_PANEL = [
  "fixed top-[4.5rem] left-[max(0.5rem,env(safe-area-inset-left))] right-[max(0.5rem,env(safe-area-inset-right))]",
  "sm:absolute sm:top-auto sm:left-auto sm:right-0 sm:mt-2 sm:w-[22rem] sm:max-w-[calc(100vw-2rem)]",
  "rounded-xl border border-slate-700 bg-slate-950 shadow-2xl z-50",
].join(" ");

export const KELAS_DAFTAR =
  "max-h-[60vh] overflow-y-auto overflow-x-hidden overscroll-contain divide-y divide-slate-800";

export const KELAS_BARIS_JUDUL = "flex items-start gap-2 text-sm text-slate-100 sm:items-center";

export const KELAS_JUDUL = "min-w-0 whitespace-normal break-words sm:truncate";

export const KELAS_ISI = "text-xs text-slate-400 break-words";
